<template>
  <div class="home">
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/bootstrap.min.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/style.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/responsive.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/colors.css" /> -->
      <!-- <link rel="stylesheet" href="https://awshk.handycdn.com/css/animate.css" /> -->
      <!-- <link rel="stylesheet" href="https://fontawesome.dashgame.com/assets/font-awesome/css/font-awesome.css" /> -->
      
      <!-- <header class="header header_style1">
         <div class="container">
            <div class="row">
               <div class="col-md-9 col-lg-10">
                  <div class="logo"><a href="index.html"><img src="../assets/template/images/logo.png" alt="#" /></a></div>
                  <div class="main_menu float-right">
                     <div class="menu">
                        <ul class="clearfix">
                           <li class="active"><a href="index.html">Home</a></li>
                           <li><a href="./privacyPolicy">Privacy policy</a></li>
                           <li><a href="./userAgreement">User agreement</a></li>
                        </ul>
                     </div>
                  </div>
               </div>
               <div class="col-md-3 col-lg-2">
                  <div class="right_bt"><a class="bt_main" href="/login">Login</a> </div>
               </div>
            </div>
         </div>
      </header> -->
      <section id="banner_parallax" class="slide_banner1">
         <div class="container">
            <div class="row">
               <div class="col-md-6">
                  <div class="full">
                     <div class="slide_cont">
                        <h2>安全自由畅聊的端对端加密APP </h2>
                        <p>蝉鸣（cicadasing）是一款可以私有部署的移动办公即时通信应用。让您可以和商务伙伴以及家人朋友无拘无束地在自己的通讯服务器进行移动办公、即时沟通、远程音视频会议等，最大程度保护您的隐私安全！</p>
                        <div class="full slide_bt">
                           <a class="white_bt bt_main download_bt ios" :href="IOS_DOWNLOAD"><i class="fa fa-apple"></i> 苹果商店</a>
                           <a class="white_bt bt_main download_bt android" :href="ANDROID_DOWNLOAD"><i class="fa fa-android"></i> 谷歌商店</a>
                           <a class="white_bt bt_main download_bt apk" :href="APK_DOWNLOAD"><i class="fa fa-download" style="transition: unset;font-size:18px;"></i> Apk下载</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="full">
                     <div class="slide_pc_img wow fadeInRight" data-wow-delay="1s" data-wow-duration="2s"> <img src="../assets/template/images/pc-banner.png" alt="#" /> </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end header -->
      <!-- section -->
      <section class="layout_padding padding_top_0">
         <div class="container">
            <div class="row margin_bottom_30">
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>私有部署</h3>
                     <p>可将系统部署在企业自有服务器或任意的云服务器中，保证用户信息、通信内容、数据文件等完全处于自主安全可控的范围。</p>
                     <p>
                        <a href="/#/instructions" class="link" style="font-size:13px;">查看私有部署安装文档</a>
                     </p>
                     <!-- <p>lo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.<br><br>Ut enim ad minima veniam quis nostrum exercitationem ullam corporis..!</p> -->
                  </div>
               </div>
               <!-- end featured cont -->
               <!-- featured image -->
               <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser1.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
            </div>
            <div class="row margin_bottom_30 bannerLayer2"> 
               <!-- featured image -->
               <div class="col-md-6 wow fadeInLeft" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser2.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>保障隐私</h3>
                     <p>不使用任何手机号码、邮箱及其他个人有关的信息进行认证审核，杜绝了个人信息泄露造成的安全隐患。</p>
                     <!-- <h3>多服务器支持</h3>
                     <p>支持同时添加多通讯服务器，可以任意加入不同的私有通讯服务器，可以自由的在不同的群体中实现同步的通讯体验。</p> -->
                  </div>
               </div>
               <!-- end featured cont -->
            </div>
            <div class="row margin_bottom_30 ">
               <!-- featured cont -->
               <div class="col-md-6 cont_theme_blog">
                  <div class="full">
                     <h3>端到端加密</h3>
                     <p>采用端到端动态加密方案，使用最高RSA 2048和AES 256 混合加密算法。内容及数据全程以密文的形式传输，杜绝第三方解密。使用网络通道加密、本地数据库加密等其他技术手段，最大强度保障了自由安全的通讯。</p>
                  </div>
               </div>
               <!-- end featured cont -->
               <!-- featured image -->
               <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5" data-wow-duration="1s">
                  <div class="full">
                     <div class="center"><img src="../assets/template/images/ser3.png" alt="#" /></div>
                  </div>
               </div>
               <!-- end featured image -->
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding gradiant_bg cross_layout">
         <div class="container">
            <div class="row">
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon1.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>赠送美元</h3>
                     </div>
                     <div class="imf_cont">
                        <p>推广期间，官网注册就送300美元等值消费券，前500名注册者可获得终身使用蝉鸣“亲情版”服务器的软件注册码。</p>
                     </div>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon2.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>圈子分组</h3>
                     </div>
                     <div class="imf_cont">
                        <p>支持圈子分组，为家人、朋友、同事设置不同的圈子。不同圈子内用户互不干扰和可见，保证生活私密性与社交的便利性。</p>
                     </div>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="information_blogs">
                     <div class="imf_icon"><img src="../assets/template/images/icon3.png" alt="#" /></div>
                     <div class="imf_head">
                        <h3>多服务器支持</h3>
                     </div>
                     <div class="imf_cont">
                        <p>支持同时添加多通讯服务器，可以任意加入不同的私有通讯服务器，可以自由的在不同的群体中实现同步的通讯体验。</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <!-- section -->
      <section class="layout_padding">
         <div class="container">
            <div class="row">
               <div class="full">
                  <div class="row">
                     <div class="col-sm-12">
                        <div class="full text_align_center">
                           <div class="heading_main center_head_border heading_style_1">
                              <h2>产品</h2>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-sm-12">
                  <div class="full" style="margin-top:10px;">
                     <div class="row">
                        <div class="col-sm-12 col-md-4" v-for="m in mealList" :key="m.id">
                           <div class="table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>{{m.name}}</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p style="color: #ccc;font-size: 22px;text-decoration: line-through;height:22px;" v-if="m.originalPrice && m.discountPrice && m.discountPrice < m.originalPrice">
                                          ${{(m.originalPrice || 0).toFixed(2)}}
                                    </p>
                                    <p style="color: #ccc;font-size: 22px;text-decoration: line-through;height:22px;" v-else></p>
                                    <p>${{(m.discountPrice || m.originalPrice || 0).toFixed(2)}}<br>
                                       <!-- <small>/month</small> -->
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li style="height:21px;">人数数量{{m.attributeData.serverPeopleNum}}人</li>
                                       <li style="height:21px;">圈子数量{{m.attributeData.circleNum}}个</li>
                                       <li style="height:21px;">管理员{{m.attributeData.adminNum}}个</li>
                                       <!-- <li style="height:21px;">{{m.attributeData.isKurento ? '支持kurento服务': ''}}</li> -->
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> 
                                 <a v-if="m.originalPrice && m.discountPrice" href="#" class="bt_main" @click="buyMeal(m)">立即购买</a>
                                 <a v-else class="bt_main" href="#" @click="toInstructions(m)">立即使用</a>
                              </div>
                           </div>
                        </div>
                        <!-- <div class="col-sm-12 col-md-4">
                           <div class="table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Basic</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$29.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="bt_main" href="/#/index.html">Buy now</a> </div>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                           <div class="active_price table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Standard</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$39.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="reverse_bt bt_main" href="/#/index.html">Buy now</a> </div>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                           <div class="table_price text_align_center">
                              <div class="table_price_head">
                                 <h5>Profesional</h5>
                              </div>
                              <div class="table_price_cont">
                                 <div class="table_price_per">
                                    <p>$45.00<br>
                                       <small>/month</small>
                                    </p>
                                 </div>
                                 <div class="table_price_cont_bottm">
                                    <ul>
                                       <li>100 MB Disk Space</li>
                                       <li>2 Subdomains</li>
                                       <li>5 Email Accounts</li>
                                       <li>Customer Support 24/7</li>
                                    </ul>
                                 </div>
                              </div>
                              <div class="table_price_bottm"> <a class="bt_main" href="/#/index.html">Buy now</a> </div>
                           </div>
                        </div> -->
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <!-- end section -->
      <div class="welcomeBox" :class="{show: showWelcome}">
         <div class="welcome">
            <!-- <div class="welcome_header">
               <div class="close el-icon-close" @click="closeWelcome"></div>
            </div> -->
            <!-- <div class="welcome_body">
               <div class="_title">欢迎使用蝉鸣...</div>
               <div class="_img">
                  <img src="../assets/img2/info.png" alt="" />
               </div>
               <div class="info1">{{$store.state.userInfo.email}},您好</div>
               <div class="info2">欢迎登录蝉鸣，$300奖励金已到账请查收！</div>
            </div> -->
            <div class="info1">{{$store.state.userInfo.email}},您好</div>
            <div class="info2">您已注册成功，恭喜获得平台赠送的 <span>300美金</span> 消费券</div>
            <div class="close">
               <span class="el-icon-circle-close" @click="closeWelcome"></span>
            </div>
         </div>
      </div>
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
// @import "../assets/template/font-awesome-4.7.0/css/font-awesome.min.css";
// .home {

// }
a.link{
   color: rgba(57,179,237,0.8);
   cursor: pointer;
   text-decoration: none;
   &:hover{
      color: rgba(57,179,237,1);;
      text-decoration: underline;
   }
}
.welcomeBox{
   position:fixed;
   background:rgba(0,0,0,0.5);
   width:100vw;
   height:100vh;
   top:0;
   left:0;
   display:flex;
   justify-content: center;
   align-items: center;
   z-index: 99;
   transition: 0.5s opacity;
   transform: translateX(100vw);
   opacity: 0;
   overflow-y: auto;
   &.show{
      transform: translateX(0);
      opacity: 1;
   }
   .welcome{
      width: 483px;
      height:529px;
      background: url("../assets/img2/gift.png") no-repeat center -50px;
      position:relative;
      .info1{
         position:absolute;
         width:100%;
         text-align: center;
         left:0;
         bottom:150px;
         font-weight: bold;
         font-size:18px;
      }
      .info2{
         position:absolute;
         width:100%;
         text-align: center;
         left:0;
         bottom:100px;
         font-size:16px;
         color:#999;
         span{
            color:#3FB6AD;
            font-weight: bold;
         }
      }
      .close{
         position:absolute;
         bottom:-20px;
         width:100%;
         text-align: center;
         .el-icon-circle-close{
            cursor: pointer;
            color:#fff;
            font-size:32px;
         }
      }
      // background: #FFFFFF;
      // box-shadow: 0px 4px 8px 0px rgba(0, 79, 66, 0.16);
      // border-radius: 2px;
      // padding:15px;
      // width:80vw;
      // .welcome_header{
      //    text-align: right;
      //    overflow: hidden;
      //    .close{
      //       transition: 0.5s all;
      //       cursor: pointer;
      //       &:hover{
      //          transform:rotate(360deg);
      //       }
      //    }
      // }
      // .welcome_body{
      //    ._title{
      //       text-align: center;
      //       color:#3FB8A4;
      //       font-weight: bold;
      //    }
      //    ._img{
      //       text-align: center;
      //       margin:15px 0;
      //    }
      //    .info1{
      //       text-align: center;
      //       font-weight: bold;
      //    }
      //    .info2{
      //       text-align: center;
      //       margin-top:15px;
      //       color:#999;
      //       font-size:13px;
      //       margin-bottom: 15px;
      //    }
      // }
   }
}
.menu-mobile{
   line-height: 28px;;
}
.download_bt{
   position:relative;
   &.ios{
      margin-right:5px;
      .fa-apple{
         transition: unset;transform: translateY(1px);font-size:18px;margin-right: 5px;
      }
      &:hover:after{
         opacity: 1;
         transform: translateX(0);
      }
      &:after{
         position:absolute;
         // display:none;
         transition:ease 0.5s all;
         opacity: 0;
         content:' ';
         width: 148px;
         height:148px;
         left:0;
         top:50px;
         z-index: 99;
         transform: translateX(99px);
         background:url("../assets/image/iosDownload.png");
         background-size:148px;
      }
   }
   &.android{
      .fa-android{
         transition: unset;font-size:18px;margin-right: 5px;
      }
      &:hover:after{
         opacity: 1;
         transform: translateX(0);
      }
      &:after{
         position:absolute;
         // display:none;
         transition:ease 0.5s all;
         opacity: 0;
         content:' ';
         width: 148px;
         height:148px;
         z-index: 99;
         transform: translateX(99px);
         left:0;
         top:50px;
         background:url("../assets/image/androidDownload.png");
         background-size:148px;
      }
   }
   &.apk{
      margin-left:5px;
      .fa-download{
         transform: translateY(3px);
         margin-right: 5px;
      }

      &:hover:after{
         opacity: 1;
         transform: translateX(0);
      }
      &:after{
         position:absolute;
         // display:none;
         transition:ease 0.5s all;
         opacity: 0;
         content:' ';
         width: 148px;
         height:148px;
         z-index: 99;
         left:0;
         top:50px;
         transform: translateX(99px);
         background:url("../assets/image/apkDownload.png");
         background-size:148px;
      }
   }
}
.supports{
   overflow:hidden;
   padding:15px;
   max-width: 1200px;
   margin:auto;
   .info{
      color:#fff;
      // font-size: 13px;
      padding-left:2%;
      padding-bottom:8px;
      // border-bottom:1px solid #fff;
   }
   .qrcode{
      float:left;
      padding:8px;
      width:25%;
      text-align: center;
      .qrcode-i{
         background:#fff;
         padding:5px;
         background: #FFFFFF;
         box-shadow: 0px 3px 6px 0px rgba(0, 53, 44, 0.25);
         border-radius: 2px;
         display:inline-block;
         margin:auto;
         .img{
            text-align: center;
            img{
               // max-width:150px;
               // width:100%;
            }
         }
         .name{
            padding-top:5px;
            .avatar{
               text-align:left;
               img{
                  width:30px;
               }
               .name{
                  margin-left:15px;
               }
            }
         }
      }
   }
}
// .margin_bottom_30{
//    display:block;
//    overflow:hidden;
//    &.bannerLayer1,&.bannerLayer3{
//       .cont_theme_blog{
//          float:left;
//       }
//       .fadeInRight{
//          float:right
//       }  
//    }
//    &.bannerLayer2{
//       .cont_theme_blog{
//          float:right;
//       }
//       .fadeInRight{
//          float:left;
//       }  
//    }
// }
@media screen and (max-width: 900px){
   .supports{
      .qrcode-box{
         .qrcode{
            width:50%;
         }
      }
   }
}
@media screen and (max-width: 600px){
   .slide_bt{
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .download_bt{
         width:200px;
         margin:5px 0;
         &:after{
            display:none;
         }
         &.ios{
            margin-right:0;
         }
      }
   }
   .supports{
      .qrcode-box{
         .qrcode{
            width:100%;
         }
      }
   }
   .bannerLayer2{
         flex-direction: column-reverse;
   }
   // .margin_bottom_30{
   //    &.bannerLayer2{
   //       .cont_theme_blog{
   //          float:left;
   //       }
   //       .fadeInLeft{
   //          float:right;
   //       }  
   //    }
   // }
}
.wow{
   .full{
      .center{
         img{
            max-width: 80%;
         }
      }
   }
}
.imf_icon{
   padding:0;
   img{
      width:100%;
   }
}
</style>

<script>
// import "../assets/template/js/jquery.min.js";
// import "../assets/template/js/popper.min.js";
// import "../assets/template/js/wow.js";
// import "../assets/template/js/custom.js";
// import "../assets/template/js/bootstrap.min.js";
// import "";
import server from "@/public/service"
import {SUCCESS_CODE,ANDROID_DOWNLOAD,IOS_DOWNLOAD,APK_DOWNLOAD} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";

export default {
  title: "Dingo Group",	
  data() {
    return {
       showWelcome: true,
        mealList: [],
        IOS_DOWNLOAD,
        ANDROID_DOWNLOAD,
         APK_DOWNLOAD
    };
  },
  methods: {
      getMeal(){
         var params = {
               current:1,
               size:999,
               shelvesState: 1
         };
         server.getMeal(params).then(data=>{
            if(data.reCode === SUCCESS_CODE){
               var result = getInterfaceData(data);
               this.mealList = result.records.sort((a,b)=>a.discountPrice-b.discountPrice).slice(0,3).map(v=>{
                  try{
                     v.attributeData = JSON.parse(v.attribute);
                  }catch(e){
                     v.attributeData = {};
                  };
                  return v;
               });
            };
         });
      },
      closeWelcome(){
         this.showWelcome = false;
         this.$store.state.isRegister = false;
      },
      buyMeal(meal){
         this.$store.state.orderDetail = JSON.parse(JSON.stringify(meal));
         this.$router.push({
               path: "/orderDetail",
         });
      },
      toInstructions(){
         this.$router.push("/instructions")
      }
  },
  created(){
     this.showWelcome = !!this.$store.state.isRegister;
     this.getMeal();
  },
  mountedBefore(){
	  var map = document.createElement('script');
	  map.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyA8eaHt9Dh5H57Zh0xVTqxVdBFCvFMqFjQ&callback=initMap";
     document.body.appendChild(map)
  }
};
</script>
